/**
 *? USED ONLY in Oxylink project
 * This locale contains all translations containing the original 'zone', renamed to 'groupe'
 */
export const frRenamingSectorsAsGroup = {
    'navbar.sectors': 'Groupes',

    //* SECTORS
    'areas.details.sectionTitle': 'LISTE RÉGIONS ENFANTS',

    //* SECTORS
    'areas.create.pageTitle': 'Création groupe',
    'sectors.list.item.floatingLabelParentName': 'Groupe parent',
    'sectors.details.select.sectionTitle': 'Groupe parent',
    'sectors.details.select.title': 'Choisir un groupe parent *',
    'sectors.details.select.floatingLabel': 'Groupe parent',
    'sectors.details.select.listTitle': 'Choix du groupe parent',
    'sectors.create.select.sectionTitle': 'Groupe parent',
    'sectors.create.select.title': 'Choisir un groupe parent *',
    'sectors.create.select.floatingLabel': 'Groupe parent',
    'sectors.create.select.listTitle': 'Choix du groupe parent',

    //* AREAS
    'areas.details.detailsInfo':
        'Pas de groupe enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Groupes » où vous pourrez affecter des zones parentes.',
    'areas.create.createInfo':
        'Pas de groupe enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Groupes » où vous pourrez affecter des zones parentes.',

    //*------ SECTORS

    'sectors.list.pageTitle': 'Groupes',
    'sectors.list.sectionTitle': 'Groupes',
    'sectors.list.emptyLabel': 'Aucun groupe pour le moment.',
    'sectors.list.actions.addGroup': 'Ajouter un groupe',

    'sectors.details.detailsInfo':
        'Pas de centre enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Centres » où vous pourrez affecter des groupes parents.',
    'sectors.details.actions.save': 'Enregistrer',
    'sectors.details.actions.removeSector': 'Supprimer le groupe',
    'sectors.details.actions.disabledRemoveInfo':
        'Ce groupe contient des centres et ne peut être supprimée.',

    //* SECTORS >> DETAILS

    'sectors.details.pageTitle': 'Détails groupe',
    'sectors.details.actions.previous': 'Groupes',
    'sectors.details.dialog.title': 'Suppression de groupe',
    'sectors.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce groupe ?',

    'sectors.details.select.listInputLabel': 'Chercher un groupe',
    'sectors.details.input.name': 'Saisissez ici le nom du Groupe *',
    'sectors.details.input.code': 'Saisissez ici le code du Groupe *',

    //* SECTORS >> CREATE

    'sectors.create.pageTitle': 'Création groupe',
    'sectors.create.createInfo':
        'Pas de centre enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Centres » où vous pourrez affecter des groupes parents.',

    'sectors.create.select.listInputLabel': 'Chercher un groupe',
    'sectors.create.input.name': 'Saisissez ici le nom du Groupe *',
    'sectors.create.input.code': 'Saisissez ici le code du Groupe *',

    //* TOAST
    'sectors.import.success': 'Bravo! Groupes importés avec succès',
};
